import React from 'react'
import styled from 'styled-components'
import { ColorVariant, Heading1, NormalText } from 'styling/TypographyV2'

export interface EmptyListProps {
  icon?: React.ReactNode
  title?: string
  description?: string
  maxHeight?: string
}

export const EmptyList = ({ icon, title, description, maxHeight }: EmptyListProps) => {
  return (
    <EmptyListContainer style={{ maxHeight }}>
      <IconContainer>
        {icon || (
          <svg
            width='30'
            height='30'
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z'
              stroke='#FF9900'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M6.16251 6.16211L23.8375 23.8371'
              stroke='#FF9900'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        )}
      </IconContainer>
      <Heading1>{title || 'No items to display'}</Heading1>
      <NormalText colorVariant={ColorVariant.SECONDARY}>
        {description || 'No items match your filters.'}
      </NormalText>
    </EmptyListContainer>
  )
}

const EmptyListContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`

const IconContainer = styled.div`
  width: 4rem;
  height: 4rem;
  border: 1px solid ${({ theme }) => theme.colorOrange};
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colorOrange}10;
`
